import { isOriginHeycar } from "./JourneyType";

export enum manufacturers {
  VW = "Volkswagen",
  VWCV = "Volkswagen Nutzfahrzeuge",
  SEAT = "SEAT",
  SKODA = "Skoda",
  AUDI = "Audi",
  CUPRA = "CUPRA",
}

const marketingCardLinks = [
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.VW,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=vw.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/vw?traci_s=LEP:VW:ORG:HeyCar:Website::heycar_lead&traci_ie=heycarselect.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.VWCV,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=vwn.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection: ""
  },
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.SEAT,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=seat.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/seat?traci_s=LEP:SEAT:ORG:HeyCar:Website::heycar_lead&traci_ie=heycarselect.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.SKODA,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=skoda.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/skoda?traci_s=LEP:SKODA:ORG:HeyCar:Website::heycar_lead&traci_ie=heycarselect.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.AUDI,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=audi.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/audi?traci_s=LEP:AUDI:ORG:HeyCar:Website::heycar_lead&traci_ie=heycarselect.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "HEYCAR",
    manufacturer: manufacturers.CUPRA,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=cupra.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection: ""
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.VW,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=vw.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/vw?traci_s=LEP:VW:ORG:HeyCar:Website::heycar_lead&traci_ie=topcars.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.VWCV,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=vwn.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection: ""
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.SEAT,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=seat.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/seat?traci_s=LEP:SEAT:ORG:HeyCar:Website::heycar_lead&traci_ie=topcars.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.SKODA,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=skoda.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/skoda?traci_s=LEP:SKODA:ORG:HeyCar:Website::heycar_lead&traci_ie=topcars.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.AUDI,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=audi.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection:
      "https://private-lease-end-protection.vwfs.io/audi?traci_s=LEP:AUDI:ORG:HeyCar:Website::heycar_lead&traci_ie=topcars.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::"
  },
  {
    originSystem: "VTI_GIS",
    manufacturer: manufacturers.CUPRA,
    linkMotorInsurance:
      "https://autoversicherung.vwfs.de/vw-kfz?traci_s=MI:VW:ORG:VWFS:Website::journey_lead&traci_ie=cupra.de.leasing-online.vwfs.io/ident-succeeded:Content:MarketingCard::",
    linkLeaseEndProtection: ""
  },
];
export const searchMarketingCardLinks = (
  manufacturer: string,
  originSystem: string
) => {
  return marketingCardLinks.filter((card) => {
    return (
      card.manufacturer === manufacturer &&
      (isOriginHeycar(originSystem) || (originSystem === card.originSystem))
    );
  });
};
